export default __webpack_public_path__ + "static/media/nav-adas.42faf31a.jpg";